export const enGb = {
  "Add a new user": "Add a new user",
  add: "Add",
  addNewUser: "Add new user",
  areYouSureYouWantToDeactivate2fa:
    "Are you sure you want to deactivate two-factor authentication for this user? Re-enabling will require user to setup 2FA again.",
  backToAllUsers: "Back to all users",
  checkedPermissions: "{{checked}} / {{total}} permissions",
  configuration: "Configuration",
  couldNotRemove2fa:
    "Could not remove two-factor authentication. Please try again later.",
  edit: "Edit",
  editUser: "Edit user",
  "Email address": "Email address",
  givenUsercouldNotBeFound:
    "Given user could not be found. Make sure you are on correct mode (production/sandbox).",
  "Merchant Users": "Merchant Users",
  merchantUsers: "Merchant Users",
  Name: "Name",
  pageDescription: `Users who can access the Volt merchant portal from your organisation.
Admin users can add other users, configure applications and make changes to your merchant account.
Standard users can view your transactions and invoices.`,
  Password: "Password",
  "Password confirmation": "Password confirmation",
  Permissions: "Permissions",
  permissionsAmount: "{{count}} permission",
  permissionsAmount_plural: "{{count}} permissions",
  permissionsPreviewSectionDescription:
    "This is the overview of permissions {{name}} has on Fuzebox",
  remove2fa: "Remove 2FA",
  remove2factorAuthentication: "Remove two-factor authentication",
  roles: "roles",
  saveChanges: "Save changes",
  theUserHasBeenCreated:
    "The user has been created. An e-mail verification link has been sent to {{email}} to finish the set-up.",
  theUserHasBeenModified: "The user has been modified.",
  twoFaAuthenticatorCannotBeDisabledForVoltAdmins:
    "Two factor authentication cannot be disabled for Volt Admins",
  twoFactorAuthenticator: "Two-factor authentication",
  twoFaHasBeenSuccesfullyRemovedForThisUser:
    "Two-factor authentication has been successfully removed for this user.",
  twoFaIsDisabled: "Two-factor authentication is disabled",
  twoFaIsEnabled: "Two-factor authentication is enabled",
  user: "User",
  userNotFound: "User not found",
  users: "Users",
};
